export class ImpersonationRequest {
    public userId: string;

    constructor(userId: string) {
        this.userId = userId;
    }
}